<mat-action-list>
  @if (isLoading$ | async) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      {{ 'loading' | translate }}<span class="loading-dots">...</span>
    </div>
  }
  @for (soilAnalysis of soilAnalyses; track soilAnalysis) {
    <a mat-list-item (click)="selectSoilAnalysis(soilAnalysis)">
      @if (isLinkedCropFieldEmpty(soilAnalysis)) {
        <mat-icon>warning</mat-icon>
      }
      {{ soilAnalysis?.description }}
      ({{ soilAnalysis?.samplingDateTime | date: 'yyyy' }})
      @if (showCoordinateWarning(soilAnalysis)) {
        ({{ 'soilAnalysisCoordinatesNotAvailable' | translate }})
      }
    </a>
  }
</mat-action-list>
